import { ReactComponent as Target } from './icon.svg'

export default Target
